<template>
    <div class="auth-finalize-step-container">
        <div class="finalize-msg">
            <p class="title">All set!</p>
            <p class="msg">
                {{ msg }}
            </p>
            <p class="description">
                {{ description }}
            </p>
        </div>
        <div class="finalize-cta">
            <button @click="redirectGetStarted" class="cta-btn">Get Started</button>
        </div>
        <button @click="handleAuthOverlayClick" class="close-auth-btn">Close</button>
    </div>
</template>
<script>
    import { useAuth } from '@/composables/auth/useAuth'
    export default {
        name: 'AuthFinalizeStep',
        props: {
            mode: {
                required: true,
                type: String,
                validator: (v) => ['artist', 'venue'].includes(v)
            }
        },
        setup() {
            const { userValues, handleAuthOverlayClick } = useAuth()
            return {
                userValues,
                handleAuthOverlayClick
            }
        },
        data: () => ({
            msg: '',
            description: ''
        }),
        created() {
            switch (this.mode) {
                case 'artist':
                    return this.populateArtistMsg()
                case 'venue':
                    return this.populateVenueMsg()
                default:
                    return
            }
        },
        methods: {
            populateArtistMsg() {
                this.msg = `Your artist profile for ${this.userValues.bandName} is set up.`
                this.description =
                    'You can now make offers for events you’ve been invited to, apply for open shows on Hedlyner and share your avails with prospective venues..'
            },
            populateVenueMsg() {
                this.msg = `Your booking profile for ${this.userValues.venueName} is set up.`
                this.description =
                    'Now we’ve got the basics, head over to the Get Started Page to continue on your journey.'
            },
            redirectOpportunities() {
                window.location.href = '/opportunities'
            },
            redirectGetStarted() {
                window.location.href = '/profile/get-started'
            }
        }
    }
</script>
<style lang="scss" scoped>
    .auth-finalize-step-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 40px;
        width: 100%;

        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }
        .finalize-msg {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 12px;
            width: 100%;

            .title {
                color: #dedede;
                font-family: Instrument Sans;
                font-size: 38px;
                font-style: normal;
                font-weight: 500;
                line-height: 110%;
                letter-spacing: -0.76px;
            }
            .msg {
                color: #cdeb09;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
            }
            .description {
                color: #8b8b8b;
                font-family: Instrument Sans;
                font-size: 16px;
                font-style: normal;
                font-weight: 550;
                line-height: 125%;
            }
        }
        .finalize-cta {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            gap: 20px;
            width: 100%;

            .cta-btn {
                padding: 11px 30px 12px 30px;
                border-radius: 100px;
                background: #cdeb09;
                width: 100%;
                color: black;
                font-family: Instrument Sans;
                font-size: 18px;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
            }
            .profile-btn {
                padding: 11px 30px 12px 30px;
                border-radius: 100px;
                border: 1px solid #cdeb09;
                background: none;
                width: 100%;
                color: #cdeb09;
                font-family: Instrument Sans;
                font-size: 18px;
                font-style: normal;
                font-weight: 550;
                line-height: 120%;
            }
        }
        .close-auth-btn {
            color: #8b8b8b;
            text-align: center;
            font-family: Instrument Sans;
            font-size: 16px;
            font-style: normal;
            font-weight: 550;
            line-height: 125%;
            text-decoration-line: underline;
            background: none;
        }
    }
</style>
